import script from "./NoMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./NoMessage.vue?vue&type=script&setup=true&lang=js"

import "./NoMessage.vue?vue&type=style&index=0&id=3ce6bbf3&lang=scss"

const __exports__ = script;

export default __exports__